import Hero from '../sections/Hero';
import LaunchSection from '../sections/LaunchSection';
import PlatformSection from '../sections/PlatformSection';
import ComparisonSection from '../sections/ComparisonSection';
import AISection from '../sections/AISection';
import OldAlexHubSection from '../sections/OldAlexHubSection';
import ContactSection from '../sections/ContactSection';

export default function Home() {
  return (
    <>
      <Hero />
      <LaunchSection />
      <PlatformSection />
      <ComparisonSection />
      <AISection />
      <OldAlexHubSection />
      <ContactSection />
    </>
  );
}
